/*Tps-report*/
if (window.location.pathname.includes("reports/invoice")) {
  window.makeDatepickers = datepickers => {
    datepickers.each(function(index, element) {
      $(element).addClass("initialized");

      $(element).datepicker({
        uiLibrary: "bootstrap4",
        value: $(element).val(),
        minDate: new Date(),
        disableDaysOfWeek: [0, 6],
        showOtherMonths: true,
        change: function(e) {
          if (!e.currentTarget.value) return;

          $.ajax({
            url: "/api/report/invoices/snooze",
            method: "post",
            data: { id: $(this).data("id"), date: e.currentTarget.value },
            dataType: "json",
            success: function(response) {
              if (!moment(response.snooze_date).isBetween(moment(range_start_date), moment(range_end_date), "days", "[]")) {
                $(e.currentTarget)
                  .closest("tr")
                  .remove();
              }

              message("Invoice successfully snoozed.");
            }
          });
        }
      });
    });
  };

  // Date range picker
  let range_start_date = $("#startDatePicker").val();
  let range_end_date = $("#endDatePicker").val();

  $("#startDatePicker").datepicker({
    uiLibrary: "bootstrap4",
    iconsLibrary: "fontawesome",
    maxDate: function() {
      return $("#endDatePicker").val();
    },
    open: function() {
      $("#startDatePicker")
        .closest(".form-daterangepicker")
        .addClass("active");
    },
    close: function() {
      $("#startDatePicker")
        .closest(".form-daterangepicker")
        .removeClass("active");
    },
    change: function(e) {
      if (range_start_date !== e.currentTarget.value) {
        range_start_date = e.currentTarget.value;
        refreshTables();
      }
    }
  });

  $("#endDatePicker").datepicker({
    uiLibrary: "bootstrap4",
    iconsLibrary: "fontawesome",
    minDate: function() {
      return $("#startDatePicker").val();
    },
    open: function() {
      $("#endDatePicker")
        .closest(".form-daterangepicker")
        .addClass("active");
    },
    close: function() {
      $("#endDatePicker")
        .closest(".form-daterangepicker")
        .removeClass("active");
    },
    change: function(e) {
      if (range_end_date !== e.currentTarget.value) {
        range_end_date = e.currentTarget.value;
        refreshTables();
      }
    }
  });

  function updateTable(table, daterange, options, columns) {
    const newData = { ...table.data("post_data"), ...daterange };

    if (!$.fn.dataTable.isDataTable(table)) {
      console.error("Incorrect datatable component!");
      return;
    }

    table.DataTable().destroy();
    table.empty();
    let html = "<thead><tr>";
    let header = columns;
    for (let i in header) {
      html += `<td data-column="${i}" class="col-${i}">${header[i]}</td>`;
    }
    html += "</tr></thead>";
    table.html(html);
    table.data("post_data", newData);
    table.data("options", options);
    window.dataTableInstance(table);
    $("[name='invoice_search']").trigger("keyup");
  }

  var options = {
    columnDefs: [
      {
        render: function(data, type, row) {
          return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
        },
        targets: "col-policyholder"
      },
      {
        render(data, type, row) {
          return `<span class="d-none">${row.start_date}</span>${data}`;
        },
        targets: "col-invoice_dates"
      },
      {
        render(data, type, row) {
          return "$" + window.formatMoney(data);
        },
        targets: "col-amount"
      },
      {
        render: function(data, type, row) {
          return `<div class="d-flex justify-content-center align-items-center">
            <div class="form-control-wrap form-datepicker">
              <input
                id="dp-${row.id}"
                type="text"
                name="snooze_date"
                data-id='${row.id}'
                class="form-control datepicker border-0"
                style="opacity:0;width:0;"
                value="${moment(row.snooze_date).format("MM/DD/YYYY")}"
              />
              <label for="dp-${row.id}" class='form-control-date-custom border-0 pr-0 mb-0'></label>
            </div>
          </div>`;
        },
        targets: "col-snooze_date"
      },
      {
        render: function(data, type, row) {
          return `<div class="btn-group">
            <button class="btn btn-secondary datatable-command btn-invoice-action" data-invoice_id="${row.id}">Action</button>
            <button class="btn btn-danger datatable-command btn-icon" data-id="${row.id}" data-type="delete"><i class="fas fa-trash-alt"></i></button>
          </div>`;
        },
        targets: "col-completed"
      }
    ],
    order: [[6, "asc"]],
    infoCallback: function(settings, json) {
      window.makeDatepickers($(".form-control.datepicker:not('.initialized')"));
    },
    buttons: [{ extend: "excel", text: '<i class="fas fa-file-download"></i>' }]
  };

  var hotelOptions = {
    columnDefs: [
      {
        render: function(data, type, row) {
          return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
        },
        targets: "col-policyholder"
      },
      {
        render(data, type, row) {
          return `<span class="d-none">${row.start_date}</span>${data}`;
        },
        targets: "col-invoice_dates"
      },
      {
        render(data, type, row) {
          return "$" + window.formatMoney(data);
        },
        targets: "col-amount"
      },
      {
        render: function(data, type, row) {
          return `<div class="d-flex justify-content-center align-items-center">
            <div class="form-control-wrap form-datepicker">
              <input
                id="dp-${row.id}"
                type="text"
                name="snooze_date"
                data-id='${row.id}'
                class="form-control datepicker border-0"
                style="opacity:0;width:0;"
                value="${moment(row.snooze_date).format("MM/DD/YYYY")}"
              />
              <label for="dp-${row.id}" class='form-control-date-custom border-0 pr-0 mb-0'></label>
            </div>
          </div>`;
        },
        targets: "col-snooze_date"
      },
      {
        render: function(data, type, row) {
          return `<div class="btn-group">
            <button class="btn btn-secondary datatable-command btn-invoice-action" data-invoice_id="${row.id}">Action</button>
            <button class="btn btn-danger datatable-command btn-icon" data-id="${row.id}" data-type="delete"><i class="fas fa-trash-alt"></i></button>
          </div>`;
        },
        targets: "col-completed"
      }
    ],
    order: [[7, "asc"]],
    infoCallback: function(settings, json) {
      window.makeDatepickers($(".form-control.datepicker:not('.initialized')"));
    },
    buttons: [{ extend: "excel", text: '<i class="fas fa-file-download"></i>' }]
  };

  $.each($(".data-table"), function() {
    $(this).data("options", $(this).hasClass("table-hotel") ? hotelOptions : options);
  });

  $(".data-table").on("click", ".btn-invoice-action", async function() {
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    Swal.fire({
      title: "Invoice Report Action",
      allowOutsideClick: false,
      heightAuto: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const modalData = await getInvoiceData(data);

    Swal.fire({
      title: "Invoice Report Action",
      html: `<div id="invoiceAction">
        <v-invoice-action
          :invoice="data.invoice"
          :placement="data.placement"
          :adjusters="data.adjusters"
          :property="data.property"
          :budget="data.budget"
          :hotel="data.hotel"
        ></v-invoice-action>
      </div>`,
      icon: undefined,
      showCancelButton: true,
      cancelButtonText: "Close",
      cancelButtonColor: "#8b8c8e",
      showDenyButton: true,
      denyButtonText: modalData.invoice.pdf_path ? "Update PDF" : "Create PDF",
      denyButtonColor: "#0285ed",
      confirmButtonText: "Complete",
      confirmButtonColor: "#064a27",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      width: 1024,
      heightAuto: false,
      allowOutsideClick: () => !Swal.isLoading(),
      allowEscapeKey: () => !Swal.isLoading(),
      allowEnterKey: () => !Swal.isLoading(),
      didOpen: () => {
        const pendingButton = document.createElement("button");
        pendingButton.textContent = "Pending Send";
        pendingButton.classList.add("swal2-deny", "swal2-submit", "swal2-styled");
        pendingButton.style.backgroundColor = "#c7a723";
        pendingButton.type = "button";
        pendingButton.addEventListener("click", saveInvoice);

        const denyButton = document.querySelector(".swal2-deny");
        denyButton.parentNode.insertBefore(pendingButton, denyButton.nextSibling);
      },
      preDeny: async () => {
        window.tpsFormCallback = async function() {
          try {
            message("Generating PDF.");
            Swal.disableButtons();
            const id = data.id;
            const property_id = !["hotel_placement", "frv"].includes(data.created_from) ? data.property_id : null;
            const { blob, xhr } = await createPdf(id, property_id);
            const contentDisposition = xhr.getResponseHeader("Content-Disposition");
            let filename = "invoice_report.pdf"; // Default name

            if (contentDisposition) {
              const contentDispositionArr = contentDisposition.split("filename=");
              if (contentDispositionArr[1]) filename = contentDispositionArr[1];
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            document.querySelector(".swal2-submit").disabled = false;
            modalData.invoice.pdf_path = `invoices/${filename}.pdf`;
            $(".swal2-deny:not(.swal2-submit)").text("Update PDF");
            message("PDF is downloaded.");
            document.querySelector(".swal2-submit").disabled = false;
            Swal.enableButtons();
            refreshTables();
          } catch (error) {
            Swal.showValidationMessage(`There is something wrong!`);
            document.querySelector(".swal2-submit").disabled = false;
            Swal.enableButtons();
          }
        };
        saveInvoice();
        return false;
      },
      preConfirm: async () => {
        window.tpsFormCallback = async function() {
          Swal.disableButtons();
          const today = new Date();
          const year = today.getFullYear();
          const month = String(today.getMonth() + 1).padStart(2, "0");
          const day = String(today.getDate()).padStart(2, "0");
          const formattedDate = `${year}-${month}-${day}`;
          const invoice = {
            invoice_id: data.id,
            invoice: {
              completed: 1,
              completed_date: formattedDate
            },
            in_qb: 1
          };

          try {
            document.querySelector(".swal2-submit").disabled = true;
            const result = await confirmUpdate(invoice);

            if (result.logs) app.appendChangeLog(result.logs);

            table
              .DataTable()
              .row(tr)
              .remove()
              .draw();

            Swal.fire("Completed", "Invoice is completed.", "success");
            refreshTables();
          } catch (e) {
            Swal.showValidationMessage(`There is something wrong!`);
            document.querySelector(".swal2-submit").disabled = false;
            Swal.enableButtons();
          }
        };
        saveInvoice();
        return false;
      },
      onRender: () => {
        new Vue({
          el: `#invoiceAction`,
          data: { data: modalData }
        });
      }
    }).then(result => {
      if (result.isDismissed) return;
    });
  });

  function saveInvoice() {
    Swal.resetValidationMessage();
    Swal.disableButtons();
    document.querySelector(".swal2-submit").disabled = true;

    $("#invoiceAction form").submit();
  }

  function getInvoiceData(data) {
    return new Promise((resolve, reject) => {
      const id = data.id;
      const property_id = !["hotel_placement", "frv"].includes(data.created_from) ? data.property_id : null;

      $.ajax({
        url: `/api/invoice_data/${id}?property_id=${property_id || ""}`,
        method: "GET",
        dataType: "json",
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  }

  function confirmUpdate(data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/api/invoice_action?log=1`,
        method: "POST",
        data,
        dataType: "json",
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  }

  function createPdf(id, property_id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/pdf/generate_invoice/${id}?property_id=${property_id || ""}&save=true`,
        method: "GET",
        xhrFields: { responseType: "blob" },
        success: (blob, status, xhr) => resolve({ blob, xhr }),
        error: response => reject(response)
      });
    });
  }

  function refreshTables() {
    updateTable($(".data-table.table-budget"), { start_date: range_start_date, end_date: range_end_date }, options, app.table_keys);
    updateTable($(".data-table.table-hotel"), { start_date: range_start_date, end_date: range_end_date }, hotelOptions, app.hotel_table_keys);
    updateTable($(".data-table.table-status"), { start_date: range_start_date, end_date: range_end_date }, options, app.table_keys);
    updateTable($(".data-table.table-frv"), { start_date: range_start_date, end_date: range_end_date }, options, app.table_keys);
  }

  $(window).on("form-success", function(action, response) {
    if (response.logs) app.appendChangeLog(response.logs);

    if (typeof window.tpsFormCallback === "function") {
      window.tpsFormCallback();
      window.tpsFormCallback = null;
    } else {
      document.querySelector(".swal2-submit").disabled = false;
      Swal.enableButtons();
      message("Invoice is pending to be sent.");
      refreshTables();
    }
  });

  $(window).on("form-error", function() {
    Swal.enableButtons();
    document.querySelector(".swal2-submit").disabled = false;
    Swal.showValidationMessage(`There is something wrong!`);
  });

  // Search functionality for all tables
  $("[name='invoice_search']").on("keyup", function() {
    let val = $(this).val();
    $.each($(".data-table"), function() {
      $(this)
        .DataTable()
        .search(val)
        .draw();
    });
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/invoices.js